module.exports = __webpack_public_path__ + "static/media/23.ac2dbae5.jpeg";